import { CfAsset } from '../asset';
import { CfLink } from '../link';

export function mapCfEntityToCfCampaignBanner(cfEntity = {}) {
    const { fields } = cfEntity;

    const {
        title,
        text,
        textColor,
        ctaColor,
        image,
        mobileImage,
        tabletImage,
        cta,
        ctaBehaviour,
        backgroundColor,
        carouselImage,
        backgroundType,
        carouselDesktopImage,
        carouselTabletImage,
        carouselMobileImage,
    } = fields || {};

    return {
        title,
        text,
        ctaColor: !!ctaColor ? ctaColor : 'red',
        textColor: textColor && textColor,
        image: image && CfAsset.mapCfEntity(image),
        mobileImage: mobileImage && CfAsset.mapCfEntity(mobileImage),
        tabletImage: tabletImage && CfAsset.mapCfEntity(tabletImage),
        cta: cta && CfLink.mapCfEntity(cta),
        ctaBehaviour,
        backgroundType: backgroundType && backgroundType,
        carouselImage: carouselImage && CfAsset.mapCfEntity(carouselImage),
        carouselDesktopImage: carouselDesktopImage && CfAsset.mapCfEntity(carouselDesktopImage),
        carouselTabletImage: carouselTabletImage && CfAsset.mapCfEntity(carouselTabletImage),
        carouselMobileImage: carouselMobileImage && CfAsset.mapCfEntity(carouselMobileImage),
        backgroundColor: backgroundColor && backgroundColor,
    };
}
